"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargePagination = exports.Pagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _ChevronIcon = require("../../svgs/ChevronIcon");

var _Theme = require("../../Theme");

var _Flex = require("../Flex");

var _Link = require("../Link");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Pagination */
var Pagination = function Pagination(_ref) {
  var getHref = _ref.getHref,
      hasNextPage = _ref.hasNextPage,
      onClick = _ref.onClick,
      onNext = _ref.onNext,
      _ref$pageCursors = _ref.pageCursors,
      around = _ref$pageCursors.around,
      first = _ref$pageCursors.first,
      last = _ref$pageCursors.last,
      previous = _ref$pageCursors.previous,
      rest = _objectWithoutProperties(_ref, ["getHref", "hasNextPage", "onClick", "onNext", "pageCursors"]);

  var tokens = (0, _Theme.useThemeConfig)({
    v2: {
      order: {
        pages: 1,
        prev: 2,
        next: 3
      },
      textVariant: "mediumText",
      containerProps: {
        flexDirection: "row",
        justifyContent: "flex-end",
        mr: -1
      },
      pagesProps: {
        pr: 4
      },
      ellipsisProps: {
        color: "black30"
      }
    },
    v3: {
      order: {
        prev: 1,
        pages: 2,
        next: 3
      },
      textVariant: "sm",
      containerProps: {
        justifyContent: "space-between"
      },
      pagesProps: {},
      ellipsisProps: {
        color: "black60"
      }
    }
  });

  var handlePrevClick = function handlePrevClick(event) {
    if (previous) {
      onClick && onClick(previous.cursor, previous.page, event);
    }
  };

  var handleNextClick = function handleNextClick(event) {
    onNext && onNext(event, nextPage);
  };

  var nextPage = ((previous === null || previous === void 0 ? void 0 : previous.page) || 0) + 2;
  return /*#__PURE__*/_react.default.createElement(_Text.Text, _extends({
    as: "nav",
    "aria-label": "Pagination",
    display: "flex",
    variant: tokens.textVariant,
    lineHeight: 1,
    alignItems: "center"
  }, tokens.containerProps, rest), /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    order: tokens.order.pages
  }, tokens.pagesProps), first && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Page, {
    onClick: onClick,
    pageCursor: first,
    getHref: getHref
  }), /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    alignItems: "center",
    p: 0.5
  }, tokens.ellipsisProps), "\u2026")), around.map(function (pageCursor) {
    return /*#__PURE__*/_react.default.createElement(Page, {
      getHref: getHref,
      key: pageCursor.page,
      onClick: onClick,
      pageCursor: pageCursor
    });
  }), last && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    alignItems: "center",
    p: 0.5
  }, tokens.ellipsisProps), "\u2026"), /*#__PURE__*/_react.default.createElement(Page, {
    onClick: onClick,
    pageCursor: last,
    getHref: getHref
  }))), /*#__PURE__*/_react.default.createElement(NextPrevButton, {
    "data-testid": "prev",
    "aria-label": "Previous",
    order: tokens.order.prev,
    getHref: getHref,
    onClick: handlePrevClick,
    page: previous === null || previous === void 0 ? void 0 : previous.page,
    disabled: !previous,
    pr: 0.5
  }, /*#__PURE__*/_react.default.createElement(_ChevronIcon.ChevronIcon, {
    pr: 0.5,
    direction: "left",
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("span", null, "Prev")), /*#__PURE__*/_react.default.createElement(NextPrevButton, {
    "data-testid": "next",
    order: tokens.order.next,
    getHref: getHref,
    onClick: handleNextClick,
    page: nextPage,
    disabled: !hasNextPage,
    pl: 0.5
  }, /*#__PURE__*/_react.default.createElement("span", null, "Next"), /*#__PURE__*/_react.default.createElement(_ChevronIcon.ChevronIcon, {
    pl: 0.5,
    direction: "right",
    height: 12,
    fill: "currentColor"
  })));
};

exports.Pagination = Pagination;
Pagination.displayName = "Pagination";

var Page = function Page(_ref2) {
  var getHref = _ref2.getHref,
      onClick = _ref2.onClick,
      _ref2$pageCursor = _ref2.pageCursor,
      cursor = _ref2$pageCursor.cursor,
      isCurrent = _ref2$pageCursor.isCurrent,
      page = _ref2$pageCursor.page,
      rest = _objectWithoutProperties(_ref2, ["getHref", "onClick", "pageCursor"]);

  var tokens = (0, _Theme.useThemeConfig)({
    v2: {
      states: {
        inactive: {
          bg: "transparent"
        },
        active: {
          bg: "black5"
        }
      }
    },
    v3: {
      states: {
        inactive: {
          color: "black60"
        },
        active: {
          color: "black100"
        }
      }
    }
  });

  var handleClick = function handleClick(event) {
    onClick && onClick(cursor, page, event);
  };

  var href = page && typeof getHref !== "undefined" ? getHref(page) : "";
  return /*#__PURE__*/_react.default.createElement(_Link.Link, _extends({
    href: href,
    onClick: handleClick,
    underlineBehavior: "hover",
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    p: 0.5
  }, isCurrent ? _objectSpread(_objectSpread({}, tokens.states.active), {}, {
    "aria-current": "page"
  }) : tokens.states.inactive, rest), page);
};

Page.displayName = "Page";

var NextPrevButton = function NextPrevButton(_ref3) {
  var disabled = _ref3.disabled,
      getHref = _ref3.getHref,
      onClick = _ref3.onClick,
      page = _ref3.page,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["disabled", "getHref", "onClick", "page", "children"]);

  var href = !disabled && page && typeof getHref !== "undefined" ? getHref(page) : "";

  if (disabled) {
    return /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
      display: "flex",
      alignItems: "center",
      color: "black30",
      py: 0.5
    }, rest), children);
  }

  return /*#__PURE__*/_react.default.createElement(_Link.Link, _extends({
    href: href,
    onClick: onClick,
    underlineBehavior: "hover",
    display: "flex",
    alignItems: "center",
    py: 0.5,
    style: !disabled ? {
      opacity: 1,
      pointerEvents: "inherit"
    } : {
      opacity: 0.1,
      pointerEvents: "none"
    }
  }, rest), children);
};

NextPrevButton.displayName = "NextPrevButton";

/**
 * Alias of Pagination
 * @deprecated Use `Pagination`
 */
var LargePagination = Pagination;
exports.LargePagination = LargePagination;
//# sourceMappingURL=Pagination.js.map